import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "672dcb4f-87ce-4df4-ae37-c4be03417708",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/10/task/task-1-item-1.svg`,
    },
  },
  {
    id: "a29980ad-0088-41a4-b539-426f737f13c6",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/10/task/task-1-item-2.svg`,
    },
  },
  {
    id: "4d9c1345-d362-4c32-b35c-10b3201d1576",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/10/task/task-1-item-3.svg`,
    },
  },
  {
    id: "54acbe5c-6d0c-40fe-b0b5-fde28bb84a40",
    content: "",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/10/task/task-1-item-4.svg`,
    },
  },
];

export const task: Task = {
  id: "968020e8-0856-4c3b-b65f-00b2d65f96e3",
  solutionType: "order",
  type: "orderImages",
  options: {
    orientation: "horizontal",
    shuffle: true,
    imageViewType: "fill",
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "a29980ad-0088-41a4-b539-426f737f13c6",
    "54acbe5c-6d0c-40fe-b0b5-fde28bb84a40",
    "672dcb4f-87ce-4df4-ae37-c4be03417708",
    "4d9c1345-d362-4c32-b35c-10b3201d1576",
  ],
};
